import React from 'react';
import { Link } from 'react-router-dom';
import { StarIcon } from '@heroicons/react/solid'
import { motion } from "framer-motion";


const NavBar = () => {
    return (
        <div className="navbar bg-cyan-800 font-mono">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabindex="0" className="btn btn-ghost text-white lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabindex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        <li className='lg:text-white'><Link to={"/home"}>Home</Link></li>
                        <li className='lg:text-white'><Link to={"/contactMe"}>Contact Me</Link></li>
                        <li className='lg:text-white'><Link to={"/blogs"}>Blogs</Link></li>
                        <li className='lg:text-white'><Link to={"/about"}>About Me</Link></li>
                    </ul>
                </div>
                <div className='flex items-center'>
                    <div className='bg-cyan-600 rounded-md shadow-slate-200 shadow-lg w-8 text-center'>
                        <motion.div
                            animate={{ rotate: [0, 360] }}
                            transition={{ repeat: false, duration: 5 }}
                        ><span className='text-3xl font-mono'>R</span></motion.div>
                        {/* <StarIcon className='w-8 h-8 text-cyan-900'></StarIcon> */}
                    </div>
                    <div className='hidden lg:block'>
                        <Link to={"/home"} className="btn btn-ghost normal-case text-sm lg:text-2xl text-white text-left">MD ROKNUZZAMAN</Link >
                    </div>

                </div>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0">
                    <li className='text-white text-xl'><Link to={"/home"}>Home</Link></li>
                    <li className='text-white text-xl'><Link to={"/contactMe"}>Contact Me</Link></li>
                    <li className='text-white text-xl'><Link to={"/blogs"}>Blogs</Link></li>
                    <li className='text-white text-xl'><Link to={"/about"}>About Me</Link></li>

                </ul>
            </div>
            <div className="navbar-end">
                <a href='Resume_of_Md_Roknuzzaman.pdf' className="btn btn-ghost border-white text-white shadow-slate-200 shadow-md text-xl" download>Download Resume</a>
            </div>
        </div>
    );
};

export default NavBar;